import React from 'react';
import { Point, Name, Select } from './styles';
export default function SelectField(_ref) {
  var id = _ref.id,
      name = _ref.name,
      placeholder = _ref.placeholder,
      required = _ref.required,
      disabled = _ref.disabled,
      options = _ref.options;
  return /*#__PURE__*/React.createElement(Point, null, /*#__PURE__*/React.createElement(Name, {
    htmlFor: id
  }, name), /*#__PURE__*/React.createElement(Select, {
    id: id,
    name: name || id,
    required: required,
    disabled: disabled
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, placeholder || name), (options || []).map(function (option, index) {
    return /*#__PURE__*/React.createElement("option", {
      key: index,
      value: option
    }, option);
  })));
}